module.exports = __webpack_public_path__ + "img/stock6.b84351c9.png";